// removed by extract-text-webpack-plugin
module.exports = {"inputWrapper":"_2wnYE","copyIcon":"_2IOYz","input":"_305Uj","hasIcon":"_2oeS3","transparent":"_1WsIv","light":"_2Txpi","dark":"_1QVQC","iconWrapper":"_15pY2","icon":"_1efHK","validation":"_2PwB8"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Input/Input.css
// module id = 480
// module chunks = 0